/**
 * Include this mixin in all components used in Form to allow for a common interface.
 *
 * IMPORTANT: This mixin relies on "field" ref to be present in your component.
 */

import { VARIANTS } from '@/components/_shared/Form/form-helper'
import { EVENT_TYPES } from '@/components/_shared/Form/Validation/FieldValidator.vue'
import { TYPES as VALIDATION_TYPES } from '@/components/_shared/Form/Validation/FieldValidation.vue'

export { TYPES as VALIDATION_TYPES } from '@/components/_shared/Form/Validation/FieldValidation.vue'

export const VALIDATION_TYPE_VARIANT_MAPPING = {
  default: VARIANTS.default,
  [VALIDATION_TYPES.error]: VARIANTS.red,
  [VALIDATION_TYPES.warning]: VARIANTS.orange,
}

export default {
  props: {
    validations: {
      type: Array,
      default: () => [],
      validator(value) {
        // validation.message && validation.type are optional
        return value.every(validation => typeof validation === 'object' && validation.validator)
      },
    },
    showMessageOn: {
      type: Object,
      default: () => ({
        [EVENT_TYPES.demand]: [VALIDATION_TYPES.error, VALIDATION_TYPES.warning],
      }),
    },
  },

  methods: {
    getFieldRef() {
      return this.$refs.field
    },

    getFieldEl() {
      return this.getFieldRef()?.getFieldEl()
    },

    getIsValid() {
      return this.getFieldRef()?.getIsValid()
    },

    getIsMessageVisible() {
      return this.getFieldRef()?.getIsMessageVisible()
    },

    focus() {
      this.getFieldRef()?.focus()
    },

    validate() {
      this.getFieldRef()?.validate()
    },

    setForceMessage(payload) {
      this.getFieldRef()?.setForceMessage(payload)
    },
  },
}
